import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { buyerUserContext } from 'application/contexts/useBuyerUser';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { BuyerUserLogout } from 'application/usecases/BuyerUserLogout';

export const useHeader = () => {
    const navigate = useNavigate();
    const diContainer = useContext(diContainerContext);
    const buyerUserLogout = diContainer.resolve(BuyerUserLogout);

    const { user, resetUser } = useContext(buyerUserContext);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const handleLogout = async () => {
        await buyerUserLogout.execute();
        window.location.href = '/buyer/login/';
        resetUser();
    };

    const menuItems = [
        { text: 'マイページ', url: '/buyer/dashboard/' },
        { text: 'ログアウト', url: '/buyer/login/', handler: handleLogout },
    ];

    const onItemClick = (item: (typeof menuItems)[0]) => {
        setPopoverOpen(false);
        item.handler?.();
        if (item.url) navigate(item.url);
    };

    return {
        user,
        popoverOpen,
        setPopoverOpen,
        menuItems,
        onItemClick,
    };
};
